import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../components/Flex";
import MicroTextArea from "../../../../../../../components/MicroTextArea";
import { VisitNoteFormValues } from "../VisitNoteTemplateForm";
import VisitNoteWithCheckBox from "../helpers/VisitNoteWithCheckBox";

interface SimpleSoapNoteFormProps {
  formik: FormikProps<VisitNoteFormValues>;
  readOnly?: boolean;
  selectedSections?: any;
  setSelectedSections?: (sections: any) => void;
  setSelectedNoteSections?: (sections: any) => void;
  hide?: boolean;
}

export const SimpleSoapNoteForm = ({
  formik,
  readOnly,
  hide = true,
  selectedSections,
  setSelectedSections,
}: SimpleSoapNoteFormProps) => {
  const handleCheckBoxChange = (checked: boolean, section: string) => {
    setSelectedSections?.((prev: any) => {
      const newObject = {
        ...prev,
        [section]: checked
          ? (formik.values?.[section as keyof VisitNoteFormValues] as any)
          : undefined,
      };

      return newObject;
    });
  };

  return (
    <Flex flexDirection="column" gap={2} p={1} width={"100%"}>
      {/* Subjective */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.subjectiveFreeNote}
        onChange={(e) =>
          handleCheckBoxChange(e.target.checked, "subjectiveFreeNote")
        }
      >
        <MicroTextArea
          disabled={readOnly}
          label="Subjective"
          rows={4}
          variant="outlined"
          name="subjectiveFreeNote"
          placeholder="Enter subjective notes..."
          value={formik.values.subjectiveFreeNote}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />{" "}
      </VisitNoteWithCheckBox>

      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.allergyFreeText}
        onChange={(e) =>
          handleCheckBoxChange(e.target.checked, "allergyFreeText")
        }
      >
        <CustomTextArea
          disabled={readOnly}
          label="Allergy"
          id="outlined-multiline-static"
          rows={3}
          variant="outlined"
          name="allergyFreeText"
          placeholder="Enter Allergies, ex:dust <press enter> food <press enter> animal dander ...etc"
          onBlur={formik.handleBlur}
          value={formik.values?.allergyFreeText}
          onChange={formik.handleChange}
        />
      </VisitNoteWithCheckBox>

      {/* HPI */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.hpi}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "hpi")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="History of Present Illness (HPI)"
          rows={4}
          variant="outlined"
          name="hpi"
          placeholder="Enter HPI..."
          value={formik.values.hpi}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Problems */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.problems}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "problems")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="Problems"
          rows={4}
          variant="outlined"
          name="problems"
          placeholder="Enter problems..."
          value={formik.values.problems}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Habits */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.habits}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "habits")}
      >
        {" "}
        <MicroTextArea
          disabled={readOnly}
          label="Habits"
          rows={4}
          variant="outlined"
          name="habits"
          placeholder="Enter habits..."
          value={formik.values.habits}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Objective */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.objectiveFreeNote}
        onChange={(e) =>
          handleCheckBoxChange(e.target.checked, "objectiveFreeNote")
        }
      >
        <MicroTextArea
          disabled={readOnly}
          label="Objective"
          rows={4}
          variant="outlined"
          name="objectiveFreeNote"
          placeholder="Enter objective notes..."
          value={formik.values.objectiveFreeNote}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Assessment */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.assessmentFreeNote}
        onChange={(e) =>
          handleCheckBoxChange(e.target.checked, "assessmentFreeNote")
        }
      >
        {" "}
        <MicroTextArea
          disabled={readOnly}
          label="Assessment"
          rows={4}
          variant="outlined"
          name="assessmentFreeNote"
          placeholder="Enter assessment..."
          value={formik.values.assessmentFreeNote}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Plan */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.planFreeNote}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "planFreeNote")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="Plan"
          rows={4}
          variant="outlined"
          name="planFreeNote"
          placeholder="Enter plan..."
          value={formik.values.planFreeNote}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Care Plan */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.carePlan}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "carePlan")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="Care Plan"
          rows={4}
          variant="outlined"
          name="carePlan"
          placeholder="Enter care plan..."
          value={formik.values.carePlan}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Instructions */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.instruction}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "instruction")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="Instructions"
          rows={4}
          variant="outlined"
          name="instruction"
          placeholder="Enter instructions..."
          value={formik.values.instruction}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>

      {/* Follow Up */}
      <VisitNoteWithCheckBox
        hide={hide}
        checked={selectedSections?.followUp}
        onChange={(e) => handleCheckBoxChange(e.target.checked, "followUp")}
      >
        <MicroTextArea
          disabled={readOnly}
          label="Follow Up"
          rows={4}
          variant="outlined"
          name="followUp"
          placeholder="Enter follow up instructions..."
          value={formik.values.followUp}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </VisitNoteWithCheckBox>
    </Flex>
  );
};
